var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55 8.66899H4.4625C4.15625 8.77837 3.82812 8.84399 3.5 8.84399C3.15 8.84399 2.82188 8.77837 2.51562 8.66899H2.45C1.09375 8.66899 0 9.78462 0 11.119C0 11.7096 0.459375 12.169 1.05 12.169H5.95C6.51875 12.169 7 11.7096 7 11.119C7 9.78462 5.88438 8.66899 4.55 8.66899ZM12.95 0.968994H4.55C3.95937 0.968994 3.5 1.47212 3.5 2.06274V3.06899C4.00313 3.06899 4.48438 3.22212 4.9 3.46274V2.36899H12.6V8.66899H6.71562C7.13125 9.04087 7.4375 9.52212 7.59062 10.069H12.95C13.5188 10.069 14 9.58774 14 8.99712V2.06274C14 1.47212 13.5188 0.968994 12.95 0.968994ZM3.5 7.96899C4.65938 7.96899 5.6 7.05024 5.6 5.86899C5.6 4.70962 4.65938 3.76899 3.5 3.76899C2.31875 3.76899 1.4 4.70962 1.4 5.86899C1.4 7.05024 2.31875 7.96899 3.5 7.96899ZM7.175 4.64399C6.97813 4.42524 6.65 4.42524 6.45312 4.64399L6.125 4.95024C6.2125 5.25649 6.3 5.56274 6.3 5.86899C6.3 6.02212 6.27812 6.17524 6.23438 6.30649L6.825 5.73774L8.02812 6.94087C8.225 7.15962 8.55313 7.15962 8.75 6.94087L10.325 5.36587L10.8719 5.91274C11.1125 6.15337 11.55 5.97837 11.55 5.62837V3.68149C11.55 3.55024 11.4187 3.41899 11.2875 3.41899H9.34062C8.99063 3.41899 8.81563 3.85649 9.05625 4.09712L9.60312 4.64399L8.4 5.84712L7.175 4.64399Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChart);
export default __webpack_public_path__ + "static/media/user-chart.791cd773ab762768d3f161047f412e73.svg";
export { ForwardRef as ReactComponent };